import { useEffect, useMemo } from "react";
import { FIAT_DEFAULT_MIN_WITHDRAWAL_ZAR } from "../constants/fiatWithdrawal";

export function useBusinessFiatSelection({
  businessId,
  businessWalletData,
  fiat,
  selectedFiat,
  setSelectedFiat,
  setFiatBalance,
  setMinWithdrawal,
}) {
  const businessFiatOptions = useMemo(() => {
    if (!businessId) return [];
    const walletAssets = Array.isArray(businessWalletData?.assets)
      ? businessWalletData.assets
      : [];
    const fiatImageByAsset = new Map(
      (Array.isArray(fiat) ? fiat : []).map((a) => [
        String(a?.asset || "").toLowerCase(),
        a?.image || "",
      ])
    );

    const rows = walletAssets
      .filter((a) => {
        const symbol = String(a?.asset || "").toLowerCase();
        const type = String(a?.type || a?.currencyType || "").toLowerCase();
        return symbol === "zar" || type === "fiat";
      })
      .map((a) => {
        const symbol = String(a?.asset || "").toLowerCase();
        return {
          id: a?.id || a?._id || symbol || "zar",
          asset: symbol || "zar",
          assetName: a?.assetName || symbol.toUpperCase() || "ZAR",
          image: a?.image || fiatImageByAsset.get(symbol) || "",
          availableAmount: parseFloat(String(a?.availableAmount ?? 0)) || 0,
        };
      });

    const deduped = rows.filter(
      (row, idx, arr) =>
        arr.findIndex(
          (x) => String(x?.asset || "").toLowerCase() === row.asset
        ) === idx
    );
    const hasZar = deduped.some((a) => a.asset === "zar");
    if (!hasZar) {
      deduped.unshift({
        id: "zar",
        asset: "zar",
        assetName: "South African Rand",
        image: fiatImageByAsset.get("zar") || "",
        availableAmount: 0,
      });
    }
    return deduped;
  }, [businessId, businessWalletData, fiat]);

  const fiatOptions = useMemo(() => {
    if (businessId) {
      return businessFiatOptions;
    }
    return Array.isArray(fiat) ? fiat : [];
  }, [businessId, businessFiatOptions, fiat]);

  useEffect(() => {
    if (!fiatOptions.length) return;
    if (!selectedFiat || typeof selectedFiat !== "object") {
      const preferred =
        fiatOptions.find((a) => String(a?.asset).toLowerCase() === "zar") ||
        fiatOptions[0];
      setSelectedFiat(preferred);
      return;
    }
    const exists = fiatOptions.some(
      (a) =>
        String(a?.asset).toLowerCase() ===
        String(selectedFiat?.asset || "").toLowerCase()
    );
    if (!exists) {
      const preferred =
        fiatOptions.find((a) => String(a?.asset).toLowerCase() === "zar") ||
        fiatOptions[0];
      setSelectedFiat(preferred);
    }
  }, [fiatOptions, selectedFiat, setSelectedFiat]);

  useEffect(() => {
    if (!businessId) return;
    const symbol = String(selectedFiat?.asset || "zar").toLowerCase();
    const selectedRow =
      fiatOptions.find((a) => String(a?.asset).toLowerCase() === symbol) ||
      fiatOptions.find((a) => String(a?.asset).toLowerCase() === "zar");
    const amountNum = selectedRow
      ? parseFloat(String(selectedRow?.availableAmount ?? 0))
      : 0;
    setFiatBalance(Number.isNaN(amountNum) ? 0 : amountNum);
    setMinWithdrawal(FIAT_DEFAULT_MIN_WITHDRAWAL_ZAR);
  }, [businessId, selectedFiat, fiatOptions, setFiatBalance, setMinWithdrawal]);

  return { fiatOptions, businessFiatOptions };
}
